import { useContext } from "react";
import { KochavaContext } from "../context/kochavaContext";

function useKochava() {
  const kochava = useContext(KochavaContext);
  return { ...kochava };
}

export default useKochava;
